import { Photo } from "../../api/types";
import { Carousel as ResponsiveCarousel } from "react-responsive-carousel";
import { groupImagesBySlide } from "../../utils";
import { useEffect, useState } from "react";
import { theme } from "../../style/theme";
import { Icon } from "../Icon/Index";
import "./style.css";
import { Stack } from "../Stack";
import { imagesResponse } from "../../api/responses";

type Props = {
  imageList: Photo[];
};

export const ImageCarousel = ({ imageList }: Props) => {
  const safeImages =
    imageList && imageList.length > 0 ? imageList : imagesResponse;
  const [itemsPerSlide, setItemsPerSlide] = useState(
    calculateItemsPerSlide(window.innerWidth)
  );

  function calculateItemsPerSlide(windowWidth: number): number {
    return 1;
  }

  useEffect(() => {
    const handleResize = () => {
      setItemsPerSlide(1);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [itemsPerSlide]);

  const groupedImages = groupImagesBySlide(safeImages, itemsPerSlide);
  return (
    <ResponsiveCarousel
      renderArrowPrev={(onClickHandler, hasPrev) => (
        <div className="arrow-prev" style={{ zIndex: 2 }}>
          <button
            onClick={onClickHandler}
            className="button-image-carousel"
            disabled={!hasPrev}
          >
            <Icon
              iconName="ArrowBackIosRounded"
              iconColor={theme.colors.black}
              iconSize={30}
            />
          </button>
        </div>
      )}
      renderArrowNext={(onClickHandler, hasNext) => (
        <div className="arrow-next" style={{ zIndex: 2 }}>
          <button
            onClick={onClickHandler}
            className="button-image-carousel"
            disabled={!hasNext}
          >
            <Icon
              iconName="ArrowForwardIosRounded"
              iconColor={theme.colors.black}
              iconSize={30}
            />
          </button>
        </div>
      )}
    >
      {groupedImages?.map((imageGroup, index) => (
        <Stack
          key={index}
          justifycontent="center"
          paddingvertical={100}
          gap={50}
          className="carousel-container-apartments"
        >
          {imageGroup?.map((image, innerIndex) => (
            <div className="apartment-image" key={image.id}>
              <img src={image.url} alt={image.id} />
            </div>
          ))}
        </Stack>
      ))}
    </ResponsiveCarousel>
  );
};
